/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CommerceCapabilitySpec { 
    /**
     * Enable/Disable Subscription Enforcement Framework V2
     */
    subscription_enforcement_enabled?: boolean;
    /**
     * Enable/Disable VMC subscription check during host burst enablement.
     */
    vmc_burst_subscription_check_enabled?: boolean;
    /**
     * Allow activation only if an org has active commits.
     */
    commits_required?: boolean;
    /**
     * Enable/ Disable Billing
     */
    billing_enabled?: boolean;
}

